export const OEM_CONSTANTS = {
  // ADD_OEM
  ADD_OEM_REQUEST: "ADD_OEM_REQUEST",
  ADD_OEM_SUCCESS: "ADD_OEM_SUCCESS",
  ADD_OEM_FAILURE: "ADD_OEM_FAILURE",
  //   GET_OEM
  GET_OEM_REQUEST: "GET_OEM_REQUEST",
  GET_OEM_SUCCESS: "GET_OEM_SUCCESS",
  GET_OEM_FAILURE: "GET_OEM_FAILURE",
  //  EDIT_OEM
  EDIT_OEM_REQUEST: "EDIT_OEM_REQUEST",
  EDIT_OEM_SUCCESS: "EDIT_OEM_SUCCESS",
  EDIT_OEM_FAILURE: "EDIT_OEM_FAILURE",
  // DELETE_OEM
  DELETE_OEM_REQUEST: "DELETE_OEM_REQUEST",
  DELETE_OEM_SUCCESS: "DELETE_OEM_SUCCESS",
  DELETE_OEM_FAILURE: "DELETE_OEM_FAILURE",
  // OEM_STATUS
  CHANGE_OEM_STATUS_REQUEST: "CHANGE_OEM_STATUS_REQUEST",
  CHANGE_OEM_STATUS_SUCCESS: "CHANGE_OEM_STATUS_SUCCESS",
  // CHANGE_OEM_STATUS_FAILURE
  GET_SCAN_TYPES_REQUEST: "GET_SCAN_TYPES_REQUEST",
  GET_SCAN_TYPES_SUCCESS: "GET_SCAN_TYPES_SUCCESS",
  GET_SCAN_TYPES_FAILURE: "GET_SCAN_TYPES_FAILURE",
  // GET_OEM_NAMES
  GET_OEM_NAMES_REQUEST: "GET_OEM_NAMES_REQUEST",
  GET_OEM_NAMES_SUCCESS: "GET_OEM_NAMES_SUCCESS",
  GET_OEM_NAMES_FAILURE: "GET_OEM_NAMES_FAILURE",
  // RESEND_VERIFICATION_EMAIL
  RESEND_VERIFICATION_EMAIL_REQUEST: "RESEND_VERIFICATION_EMAIL_REQUEST",
  RESEND_VERIFICATION_EMAIL_SUCCESS: "RESEND_VERIFICATION_EMAIL_SUCCESS",
  RESEND_VERIFICATION_EMAIL_FAILURE: "RESEND_VERIFICATION_EMAIL_FAILURE",
};
